// extracted by mini-css-extract-plugin
module.exports = {"item":"Tags-module__item___ESG4A","text":"Tags-module__text___90E7G","icon":"Tags-module__icon___Xf8q7"};